<script setup lang="ts">

import {CheckIcon} from "vue-tabler-icons";
import type {Currency} from "~/types/subscription.types";

const {active, currency: accountCurrency} = useSubscriptionForEnvironment()

const currency = defineModel<Currency>()

watch([accountCurrency], () => {
  currency.value = accountCurrency.value ?? 'USD'
}, {immediate: true})
</script>
<template>
  <div class="my-4" v-if="!active && !accountCurrency">
    <p class="h5">
      What currency would you like to pay in?
    </p>

    <div class="d-flex gap-2 mt-2">
      <v-btn :prepend-icon="currency === 'USD' ? CheckIcon : null" @click="currency ='USD'" color="primary"
             :variant="currency === 'USD' ? 'flat' :'tonal'" class="flex-grow-1">US Dollar ($)
      </v-btn>
      <v-btn :prepend-icon="currency === 'EUR' ? CheckIcon : null" @click="currency ='EUR'" color="primary"
             :variant="currency === 'EUR' ? 'flat' :'tonal'" class="flex-grow-1">Euro (€)
      </v-btn>
    </div>
  </div>
</template>
